/**
 * Добавление логера для компонента
 * @method
 *
 * @memberof EventBus
 * @alias logger.add
 * @param {string} component - имя компонента, который хотим прослушать
 *
 * @example
 * EventBus.logger.add
 */
function add(component) {
  const self = this;

  self.loggersList[component] = {};
  self._init(component);

  return;
}

export default add;
